import { h } from "@stencil/core"

const ArrowLarge = ():SVGElement => {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="#073158" xmlns="http://www.w3.org/2000/svg">
      <g id="Arrow 40x40">
      <path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M17.6464 27.7305C17.8417 27.9258 18.1583 27.9258 18.3536 27.7305C18.5488 27.5352 18.5488 27.2187 18.3536 27.0234L12.2071 20.877L29 20.877C29.2761 20.877 29.5 20.6531 29.5 20.377C29.5 20.1008 29.2761 19.877 29 19.877L12.2071 19.8769L18.3536 13.7305C18.5488 13.5352 18.5488 13.2187 18.3536 13.0234C18.1583 12.8281 17.8417 12.8281 17.6464 13.0234L10.647 20.0228L10.6464 20.0234L10.6464 20.7305" />
      </g>
    </svg>
  );
};
export default ArrowLarge;